"use client";

import { createPath } from "@/service/routing/routing";
import { trans } from "@/service/i18n/i18n";
import { LogView } from "@/components/meds/meds-search/meds-list/log-view/log-view";
import { MedGroupCard } from "@/components/meds/med-group-card/med-group-card";
import { EmptyInfoWithCta } from "@/components/common/empty-info-with-cta";
import { MedInnCard } from "@/components/meds/med-inn-card";

export const MedsList = ({
  items,
  paramsHasFilter,
  preventLog = false,
  search,
}: {
  items: Array<MedGroupPreviewVM | MedInnPreviewVM>;
  paramsHasFilter: boolean;
  preventLog?: boolean;
  search?: string;
}) => {
  return (
    <div className={""}>
      {!preventLog && (
        <LogView
          medGroups={
            items.filter(
              ({ viewModelType }) => viewModelType === "medGroupPreview",
            ) as MedGroupPreviewVM[]
          }
          query={search as string}
        />
      )}

      <div className={"flex flex-col gap-8"}>
        {items.map((item) =>
          item.viewModelType === "medGroupPreview" ? (
            <MedGroupCard key={item.id} medGroup={item} />
          ) : (
            <MedInnCard key={item.id} inn={item} />
          ),
        )}
      </div>

      {items.length === 0 && paramsHasFilter && (
        <EmptyInfoWithCta
          link={createPath("meds.index")}
          title={trans("empty_search_for_filters")}
        />
      )}

      {items.length === 0 && !paramsHasFilter && (
        <EmptyInfoWithCta
          link={createPath("meds.index")}
          title={"Brak wyników wyszukiwania"}
        />
      )}
    </div>
  );
};
